import { render, staticRenderFns } from "./ListProjects.vue?vue&type=template&id=969dde24&"
import script from "./ListProjects.vue?vue&type=script&lang=js&"
export * from "./ListProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports